export default "__VITE_ASSET__DOXDLl9h__"